<template>
	<div>
		<svg
			:width="size"
			:height="size"
			viewBox="0 0 18 18"
			:fill="color"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M16.4508 0H1.54918C0.694992 0 0 0.694992 0 1.54918V16.4508C0 17.305 0.694992 18 1.54918 18H16.4508C17.305 18 18 17.305 18 16.4508V1.54918C18 0.694992 17.305 0 16.4508 0ZM1.54944 1.32788H16.4511C16.5731 1.32788 16.6724 1.42717 16.6724 1.54919V3.72734H1.32812V1.54919C1.32812 1.42717 1.42742 1.32788 1.54944 1.32788ZM16.4511 16.6721H1.54944C1.42742 16.6721 1.32812 16.5728 1.32812 16.4508V5.0552H16.6724V16.4508C16.6724 16.5728 16.5731 16.6721 16.4511 16.6721ZM11.7665 10.2541H9.66418V8.1518C9.66418 7.78509 9.36696 7.48787 9.00025 7.48787C8.63354 7.48787 8.33631 7.78509 8.33631 8.1518V10.2541H6.234C5.86729 10.2541 5.57007 10.5513 5.57007 10.918C5.57007 11.2848 5.86729 11.582 6.234 11.582H8.33631V13.6843C8.33631 14.051 8.63354 14.3482 9.00025 14.3482C9.36696 14.3482 9.66418 14.051 9.66418 13.6843V11.582H11.7665C12.1332 11.582 12.4304 11.2848 12.4304 10.918C12.4304 10.5513 12.1332 10.2541 11.7665 10.2541Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgAddSchedule',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
